import React from "react";

export default function TrustBar() {

  const styles = {
    footer: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: "16px",
      padding: "40px",
      background: "#F6F7FB"
    },

   card: {

  background: "rgba(255,255,255,0.42)",

  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)",

  border: "1px solid rgba(255,255,255,0.55)",

  padding: "20px",

  borderRadius: "999px",

  textAlign: "center",

  color: "#111111",

  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "1.8px",
  textTransform: "uppercase",

  boxShadow:
    `
      inset 0 1px 0 rgba(255,255,255,0.9),
      0 6px 20px rgba(0,0,0,0.04),
      0 20px 40px rgba(0,0,0,0.03)
    `,

  transform: "translateZ(0)",

  transition: "all .25s ease",
},
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.card}>OEM Verified Parts</div>

      <div style={styles.card}>Fast Global Shipping</div>

      <div style={styles.card}>Fully Tested OEM PARTS</div>

      <div style={styles.card}>Secure Checkout</div>
    </footer>
  );
}